import type { SVGProps } from 'react';
export const SvgLinkedin = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={40}
		height={40}
		fill="none"
		viewBox="0 0 40 40"
		{...props}
	>
		<rect width={40} height={40} fill="#0A66C2" rx={10} />
		<path
			fill="#fff"
			d="M29.376 9H10.624A1.624 1.624 0 0 0 9 10.624v18.752A1.624 1.624 0 0 0 10.624 31h18.752A1.624 1.624 0 0 0 31 29.376V10.624A1.624 1.624 0 0 0 29.376 9M15.557 27.741H12.25V17.235h3.307zM13.901 15.78a1.9 1.9 0 1 1 1.91-1.898 1.87 1.87 0 0 1-1.91 1.898M27.75 27.75h-3.306v-5.74c0-1.692-.72-2.215-1.649-2.215-.98 0-1.943.74-1.943 2.258v5.697h-3.308V17.242h3.181v1.456h.043c.32-.646 1.438-1.75 3.144-1.75 1.846 0 3.84 1.095 3.84 4.303z"
		/>
	</svg>
);
